import React, { Component } from 'react';

import PaginationComponent from '../components/PaginationComponent';
import TableStateCard from '../components/TableStateCard';
import { sortClass, nextSortDir, sortAriaSort } from '../utils/table';
import dateFormat from 'dateformat';
import { navigateTo } from '../utils/navigation';
import { buildPaginationQuery, getPaginatedData, scheduleDebouncedCallback, clearDebouncedCallback } from '../utils/pagination';
import { hasActiveSearch, getSearchEmptyMessage } from '../utils/tableState';

var config = process.env;

const ORDER_STATUS = { 0: 'Pendiente', 1: 'Completo' };

class TableProviderOrdersComponent extends Component {

    constructor() {
        super();
        this.state = {
            quantityShowRows: 25,
            currentPage: 1,
            totalItems: 0,
            search: '',
            searchInput: '',
            sortBy: 'id',
            sortDir: 'desc',
            data: [],
            loaded: false,
            copiedOrderId: null,
        };
    }

    componentDidMount() {
        this.fetchOrders();
    }

    componentWillUnmount() {
        clearDebouncedCallback(this, 'searchDebounceTimeout');
    }

    fetchOrders = ({
        page = this.state.currentPage,
        limit = this.state.quantityShowRows,
        search = this.state.search,
        sortBy = this.state.sortBy,
        sortDir = this.state.sortDir,
        showLoader = true,
    } = {}) => {
        if (showLoader) {
            this.setState({ loaded: false });
        }
        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        };
        const query = buildPaginationQuery({ page, limit, search, sortBy, sortDir });
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}provider-orders?${query}`, request)
        .then(res => res.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error === 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                const paginatedData = getPaginatedData(data);
                this.setState({
                    data: paginatedData.items || [],
                    quantityShowRows: paginatedData.limit || Number(limit),
                    currentPage: paginatedData.page || Number(page),
                    totalItems: paginatedData.total || 0,
                    search,
                    sortBy,
                    sortDir,
                    loaded: true,
                });
            }
        });
    }

    loadData = () => {
        if (!this.state.loaded) return <tbody></tbody>;

        const items = this.state.data.map((item, index) => this.drawRow(item, index));
        if (items.length === 0) {
            items.push(
                <tr key="empty"><td colSpan="5" style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225,229,235)' }}>
                    {getSearchEmptyMessage(this.state.searchInput || this.state.search)}
                </td></tr>
            );
        }
        return <tbody>{items}</tbody>;
    }

    createModals = () => {
        if (!this.state.loaded) return null;
        return (
            <div>
                {this.state.data.map(order => this.createModalView(order))}
            </div>
        );
    }

    createModalView = (order) => {
        return (
            <div className="modal fade" id={`modal-order-${order.id}`} role="dialog" key={order.id}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Pedido #{order.id}</h4>
                        </div>
                        <div className="modal-body" style={{ padding: '0' }}>
                            <ul style={{ marginTop: '20px' }}>
                                <li><b>Proveedor:</b> {order.providerName}</li>
                                <li><b>Fecha:</b> {dateFormat(order.createdAt, 'dS mmmm, yyyy')}</li>
                                <li><b>Estado:</b> {ORDER_STATUS[order.status]}</li>
                                {order.restockingId && <li><b>Reposición:</b> #{order.restockingId}</li>}
                            </ul>
                            <table className="transaction-history d-none dataTable no-footer dtr-inline">
                                <thead>
                                    <tr>
                                        <th style={{ width: '15%' }}>Código</th>
                                        <th style={{ width: '65%' }}>Producto</th>
                                        <th style={{ width: '20%' }}>A pedir</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {order.items.map((item, idx) => (
                                        <tr key={item.code} style={{ background: idx % 2 === 0 ? '#fff' : '#fcfcfc' }}>
                                            <td>{item.code}</td>
                                            <td>{item.name}</td>
                                            <td><strong>{item.quantityToOrder}</strong></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button className="mb-2 mr-1 btn btn-primary btn-sm" data-dismiss="modal">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    cancelOrder = (item) => {
        if (!window.confirm(`¿Cancelar el pedido #${item.id} de ${item.providerName}? Esta acción no se puede deshacer.`)) return;

        const request = {
            method: 'DELETE',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'provider-orders/' + item.id, request)
        .then(res => res.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
            } else {
                this.fetchOrders();
            }
        });
    }

    copyOrderToClipboard = (item) => {
        const text = item.items.map(i => `${i.quantityToOrder} - ${i.name}`).join('\n');
        navigator.clipboard.writeText(text).then(() => {
            this.setState({ copiedOrderId: item.id });
            setTimeout(() => this.setState({ copiedOrderId: null }), 2000);
        });
    }

    drawRow = (item, index) => {
        const statusClass = item.status === 0 ? 'text-warning' : 'text-success';
        return (
            <tr role="row" className="odd" key={item.id} style={{ background: index % 2 === 0 ? '#fff' : '#fcfcfc' }}>
                <td>{item.id}</td>
                <td>{item.providerName}</td>
                <td>{dateFormat(item.createdAt, 'dd/mm/yyyy')}</td>
                <td><span className={statusClass}>{ORDER_STATUS[item.status]}</span></td>
                <td>
                    <div className="btn-group btn-group-sm" role="group">
                        <button
                            data-toggle="modal"
                            data-target={`#modal-order-${item.id}`}
                            type="button"
                            className="btn btn-white"
                            title="Ver detalle"
                        >
                            <i className="material-icons">remove_red_eye</i>
                        </button>
                        <button
                            type="button"
                            className="btn btn-white"
                            onClick={() => this.copyOrderToClipboard(item)}
                            title="Copiar para WhatsApp"
                            style={{ color: this.state.copiedOrderId === item.id ? '#28a745' : '' }}
                        >
                            {this.state.copiedOrderId === item.id
                                ? <small><b>¡Copiado!</b></small>
                                : <i className="material-icons">content_copy</i>
                            }
                        </button>
                        {item.status === 0 && (
                            <button
                                type="button"
                                className="btn btn-white"
                                onClick={() => navigateTo(`/addRestocking?orderId=${item.id}`)}
                                title="Cargar reposición"
                            >
                                <i className="material-icons">add_shopping_cart</i>
                            </button>
                        )}
                        {item.status === 0 && (
                            <button
                                type="button"
                                className="btn btn-white"
                                onClick={() => this.cancelOrder(item)}
                                title="Cancelar pedido"
                                style={{ color: '#c4183c' }}
                            >
                                <i className="material-icons">delete_outline</i>
                            </button>
                        )}
                    </div>
                </td>
            </tr>
        );
    }

    onChangeShowRows = () => {
        const itemSelected = Number(document.getElementById('select_rows_orders').value);
        this.fetchOrders({ page: 1, limit: itemSelected });
    }

    onChangeInput = (search) => {
        this.setState({ searchInput: search });
        scheduleDebouncedCallback(this, 'searchDebounceTimeout', () => {
            this.fetchOrders({ page: 1, search, showLoader: false });
        });
    }

    orderData = (column) => {
        this.fetchOrders({
            page: 1,
            sortBy: column,
            sortDir: nextSortDir(column, this.state.sortBy, this.state.sortDir),
        });
    }

    // Props de una cabecera ordenable: la clase y el aria-sort se derivan del state, así que
    // sobreviven al remonte que provoca el loader.
    sortableHeader = (column) => ({
        onClick: () => this.orderData(column),
        className: sortClass(column, this.state.sortBy, this.state.sortDir),
        'aria-sort': sortAriaSort(column, this.state.sortBy, this.state.sortDir),
        tabIndex: '0',
    })

    render() {
        const searchActive = hasActiveSearch(this.state.searchInput, this.state.search);

        if (!this.state.loaded) {
            return <TableStateCard loading />;
        }

        if (this.state.totalItems === 0 && !searchActive) {
            return (
                <TableStateCard
                    icon="assignment"
                    title="Todavia no hay pedidos a proveedores para mostrar"
                    message="Cuando existan pedidos generados, aca vas a ver su proveedor, fecha, estado y acciones disponibles."
                />
            );
        }

        return (
            <div id="provider-orders-wrapper" className="dataTables_wrapper no-footer">
                <div className="dataTables_length">
                    <label>Show
                    <select id="select_rows_orders" value={this.state.quantityShowRows} onChange={() => this.onChangeShowRows()}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select> entries</label>
                </div>
                <div className="dataTables_filter">
                    <label>Search:
                    <input id="input_search_orders" type="search" placeholder="" value={this.state.searchInput} onChange={(e) => this.onChangeInput(e.target.value)} />
                    </label>
                </div>

                <table className="transaction-history d-none dataTable no-footer dtr-inline" role="grid">
                    <thead>
                        <tr role="row">
                            <th {...this.sortableHeader('id')} style={{ width: '8%' }}>ID</th>
                            <th {...this.sortableHeader('providerName')} style={{ width: '25%' }}>Proveedor</th>
                            <th {...this.sortableHeader('createdAt')} style={{ width: '20%' }}>Fecha</th>
                            <th {...this.sortableHeader('status')} style={{ width: '15%' }}>Estado</th>
                            <th style={{ width: '15%' }}>Acciones</th>
                        </tr>
                    </thead>
                    {this.loadData()}
                </table>

                {this.createModals()}

                <PaginationComponent
                    totalItems={this.state.totalItems}
                    quantityRows={this.state.quantityShowRows}
                    currentPage={this.state.currentPage}
                    onPageChange={(page) => this.fetchOrders({ page })}
                />
            </div>
        );
    }
}

export default TableProviderOrdersComponent;
